(function () {

  function initFurFooter(root) {

    const footers =
      root &&
      root.matches?.('[data-fur-footer]')
        ? [root]
        : Array.from(
            document.querySelectorAll(
              '[data-fur-footer]'
            )
          );


    footers.forEach(
      function (footer) {

        if (
          footer.dataset
            .furFooterInitialized ===
          'true'
        ) {
          return;
        }


        footer.dataset
          .furFooterInitialized =
          'true';


        /* =================================================
           EMAIL FOCUS
        ================================================== */

        const email =
          footer.querySelector(
            '[data-fur-footer-email]'
          );


        if (email) {

          const emailField =
            email.closest(
              '.fur-footer__email-field'
            );


          function activateEmail() {

            emailField?.classList.add(
              'is-active'
            );

          }


          function deactivateEmail() {

            if (
              email.value.trim() === ''
            ) {

              emailField?.classList.remove(
                'is-active'
              );

            }

          }


          email.addEventListener(
            'focus',
            activateEmail
          );


          email.addEventListener(
            'click',
            activateEmail
          );


          email.addEventListener(
            'blur',
            deactivateEmail
          );


          /*
           * If Shopify reloads the section and
           * the field already has a value,
           * keep the active/red underline state.
           */

          if (
            email.value.trim() !== ''
          ) {

            emailField?.classList.add(
              'is-active'
            );

          }

        }


        /* =================================================
           DISCOUNT
        ================================================== */

        const discount =
          footer.querySelector(
            '[data-fur-footer-discount]'
          );


        if (discount) {

          /*
           * Desktop:
           * CSS :hover handles the animation.
           *
           * Touch / coarse pointer:
           * clicking toggles expanded state.
           */

          const touchQuery =
            window.matchMedia(
              '(hover: none), (pointer: coarse)'
            );


          function isTouchDevice() {

            return touchQuery.matches;

          }


          function openDiscount() {

            discount.classList.add(
              'is-expanded'
            );


            discount.setAttribute(
              'aria-expanded',
              'true'
            );

          }


          function closeDiscount() {

            discount.classList.remove(
              'is-expanded'
            );


            discount.setAttribute(
              'aria-expanded',
              'false'
            );

          }


          function toggleDiscount() {

            const expanded =
              discount.classList.contains(
                'is-expanded'
              );


            if (expanded) {

              closeDiscount();

            } else {

              openDiscount();

            }

          }


          /* ===============================================
             CLICK / TAP
          =============================================== */

          discount.addEventListener(
            'click',
            function (event) {

              /*
               * Desktop mouse:
               * don't toggle permanent state.
               * Hover CSS handles everything.
               */

              if (!isTouchDevice()) {
                return;
              }


              event.preventDefault();
              event.stopPropagation();


              toggleDiscount();

            }
          );


          /* ===============================================
             CLOSE WHEN CLICKING OUTSIDE
          =============================================== */

          document.addEventListener(
            'click',
            function (event) {

              if (!isTouchDevice()) {
                return;
              }


              if (
                !discount.classList.contains(
                  'is-expanded'
                )
              ) {
                return;
              }


              if (
                discount.contains(
                  event.target
                )
              ) {
                return;
              }


              closeDiscount();

            }
          );


          /* ===============================================
             ESCAPE
          =============================================== */

          document.addEventListener(
            'keydown',
            function (event) {

              if (
                event.key !== 'Escape'
              ) {
                return;
              }


              closeDiscount();

            }
          );


          /* ===============================================
             DEVICE MODE CHANGE
          =============================================== */

          function handlePointerModeChange() {

            /*
             * If browser switches to desktop hover mode,
             * remove mobile expanded state.
             */

            if (!isTouchDevice()) {

              closeDiscount();

            }

          }


          if (
            typeof touchQuery
              .addEventListener ===
            'function'
          ) {

            touchQuery.addEventListener(
              'change',
              handlePointerModeChange
            );

          } else if (
            typeof touchQuery
              .addListener ===
            'function'
          ) {

            touchQuery.addListener(
              handlePointerModeChange
            );

          }

        }

      }
    );

  }


  /* =======================================================
     NORMAL LOAD
  ======================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        initFurFooter();

      }
    );

  } else {

    initFurFooter();

  }


  /* =======================================================
     SHOPIFY THEME EDITOR
  ======================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const footer =
        event.target.matches?.(
          '[data-fur-footer]'
        )
          ? event.target
          : event.target.querySelector?.(
              '[data-fur-footer]'
            );


      if (!footer) {
        return;
      }


      delete footer.dataset
        .furFooterInitialized;


      initFurFooter(
        footer
      );

    }
  );

})();